/* ============================================================
   Product Lightbox — sakuraselect.jp (Rise theme)
   数据来源:snippets/product-lightbox.liquid 输出的
   <script type="application/json" id="lightbox-media-data">
   ============================================================ */
(function () {
  'use strict';

  var lb = document.getElementById('productLightbox');
  var dataEl = document.getElementById('lightbox-media-data');
  if (!lb || !dataEl) return;

  var items;
  try {
    items = JSON.parse(dataEl.textContent);
  } catch (e) {
    console.error('[lightbox] media JSON 解析失败', e);
    return;
  }
  if (!items.length) return;

  /* ------------------------------------------------------------
     触发选择器:按需增删。
     覆盖 Rise 主题产品媒体的常见结构 + 手动标记的元素。
     ------------------------------------------------------------ */
  var TRIGGER_SELECTOR = [
    '.product__media img',
    '.product__media-item img',
    '.media-gallery img',
    '[data-media-id] img',
    '[data-lightbox-trigger]'
  ].join(',');

  var PLAY_INTERVAL = 3500;

  /* ---------- DOM ---------- */
  var stage    = lb.querySelector('[data-lb-stage]');
  var imageEl  = lb.querySelector('[data-lb-image]');
  var counter  = lb.querySelector('[data-lb-counter]');
  var thumbsEl = lb.querySelector('[data-lb-thumbs]');
  var gridEl   = lb.querySelector('[data-lb-gridview]');
  var progress = lb.querySelector('[data-lb-progress]');
  var btnPrev  = lb.querySelector('[data-lb-prev]');
  var btnNext  = lb.querySelector('[data-lb-next]');
  var btnClose = lb.querySelector('[data-lb-close]');
  var btnZoom  = lb.querySelector('[data-lb-zoom]');
  var btnPlay  = lb.querySelector('[data-lb-play]');
  var btnFull  = lb.querySelector('[data-lb-fullscreen]');
  var btnGrid  = lb.querySelector('[data-lb-grid]');

  /* ---------- 状态 ---------- */
  var index = 0;
  var zoom = { active: false, scale: 1, x: 0, y: 0 };
  var drag = { on: false, moved: false, startX: 0, startY: 0, baseX: 0, baseY: 0 };
  var playing = false;
  var progressRAF = null;
  var lastFocused = null;

  /* ---------- 构建缩略图与九宫格 ---------- */
  items.forEach(function (item, i) {
    var t = document.createElement('button');
    t.type = 'button';
    t.className = 'lb-thumb';
    t.setAttribute('aria-label', '第 ' + (i + 1) + ' 张');
    t.innerHTML = '<img src="' + item.thumb + '" alt="" loading="lazy">';
    t.addEventListener('click', function () { show(i); });
    thumbsEl.appendChild(t);

    var g = document.createElement('button');
    g.type = 'button';
    g.innerHTML = '<img src="' + item.thumb + '" alt="" loading="lazy">';
    g.addEventListener('click', function () { toggleGrid(false); show(i); });
    gridEl.appendChild(g);
  });
  var thumbBtns = Array.prototype.slice.call(thumbsEl.children);
  var gridBtns  = Array.prototype.slice.call(gridEl.children);

  /* ---------- 核心:显示第 i 张 ---------- */
  function show(i, instant) {
    index = ((i % items.length) + items.length) % items.length;
    resetZoom();
    if (instant) {
      imageEl.src = items[index].full;
    } else {
      stage.classList.add('is-switching');
      setTimeout(function () {
        imageEl.src = items[index].full;
        imageEl.onload = function () { stage.classList.remove('is-switching'); };
        setTimeout(function () { stage.classList.remove('is-switching'); }, 250);
      }, 120);
    }
    imageEl.alt = items[index].alt || '';
    counter.textContent = (index + 1) + ' / ' + items.length;
    thumbBtns.forEach(function (b, k) { b.classList.toggle('is-active', k === index); });
    gridBtns.forEach(function (b, k) { b.classList.toggle('is-active', k === index); });
    if (thumbBtns[index].scrollIntoView) {
      thumbBtns[index].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    // 预加载相邻两张
    [index + 1, index - 1].forEach(function (n) {
      var it = items[((n % items.length) + items.length) % items.length];
      var pre = new Image();
      pre.src = it.full;
    });
  }

  /* ---------- 打开 / 关闭 ---------- */
  function open(i) {
    lastFocused = document.activeElement;
    lb.removeAttribute('hidden');
    // 强制 reflow 保证过渡动画生效
    void lb.offsetWidth;
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    show(i, true);
    btnClose.focus();
  }
  function close() {
    stopPlay();
    toggleGrid(false);
    resetZoom();
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
    if (document.fullscreenElement) document.exitFullscreen().catch(function () {});
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* ---------- 事件委托:接管产品图点击 ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest(TRIGGER_SELECTOR) : null;
    if (!trigger || lb.classList.contains('is-open')) return;
    e.preventDefault();
    e.stopPropagation();
    open(resolveIndex(trigger));
  }, true); // 捕获阶段,抢在 Rise 自带 zoom modal 之前

  /* 根据被点击的元素推断对应第几张图 */
  function resolveIndex(el) {
    // 1. 显式指定
    if (el.dataset && el.dataset.lightboxIndex !== undefined) {
      return parseInt(el.dataset.lightboxIndex, 10) || 0;
    }
    // 2. 通过 data-media-id 匹配(Rise 媒体容器通常带这个属性)
    var host = el.closest ? el.closest('[data-media-id]') : null;
    if (host) {
      var mid = host.getAttribute('data-media-id');
      for (var k = 0; k < items.length; k++) {
        // Rise 的 data-media-id 可能是 "sectionId-mediaId" 格式,用 endsWith 兼容
        if (String(mid) === String(items[k].id) || String(mid).indexOf(String(items[k].id)) !== -1) {
          return k;
        }
      }
    }
    // 3. 按 src 文件名匹配
    var src = el.currentSrc || el.src || '';
    var base = src.split('?')[0].split('/').pop();
    if (base) {
      for (var j = 0; j < items.length; j++) {
        if (items[j].full.indexOf(base.replace(/(_\d+x\d*|_x\d+)(?=\.)/, '')) !== -1 ||
            items[j].full.split('?')[0].split('/').pop().split('.')[0].indexOf(base.split('.')[0].replace(/(_\d+x\d*|_x\d+)$/, '')) !== -1) {
          return j;
        }
      }
    }
    // 4. 兜底:在所有触发元素中的位置
    var all = Array.prototype.slice.call(document.querySelectorAll(TRIGGER_SELECTOR));
    var pos = all.indexOf(el);
    return pos >= 0 ? Math.min(pos, items.length - 1) : 0;
  }

  btnClose.addEventListener('click', close);
  btnPrev.addEventListener('click', function () { stopPlay(); show(index - 1); });
  btnNext.addEventListener('click', function () { stopPlay(); show(index + 1); });
  stage.addEventListener('click', function (e) { if (e.target === stage) close(); });

  /* ---------- 缩放 ---------- */
  function applyTransform() {
    imageEl.style.transform = 'translate(' + zoom.x + 'px,' + zoom.y + 'px) scale(' + zoom.scale + ')';
  }
  function setZoom(scale, cx, cy) {
    var prev = zoom.scale;
    zoom.scale = Math.min(Math.max(scale, 1), 4);
    if (zoom.scale === 1) return resetZoom();
    if (cx !== undefined) {
      var rect = imageEl.getBoundingClientRect();
      var ox = cx - rect.left - rect.width / 2;
      var oy = cy - rect.top - rect.height / 2;
      var ratio = zoom.scale / prev - 1;
      zoom.x -= ox * ratio;
      zoom.y -= oy * ratio;
    }
    zoom.active = true;
    stage.classList.add('is-zoomed');
    lb.classList.add('is-zoomed');
    applyTransform();
  }
  function resetZoom() {
    zoom = { active: false, scale: 1, x: 0, y: 0 };
    stage.classList.remove('is-zoomed');
    lb.classList.remove('is-zoomed');
    imageEl.style.transform = '';
  }

  btnZoom.addEventListener('click', function () {
    zoom.active ? resetZoom() : setZoom(2);
  });
  imageEl.addEventListener('dblclick', function (e) {
    e.preventDefault();
    zoom.active ? resetZoom() : setZoom(2.5, e.clientX, e.clientY);
  });
  imageEl.addEventListener('click', function (e) {
    if (!zoom.active && !drag.moved) setZoom(2, e.clientX, e.clientY);
  });
  stage.addEventListener('wheel', function (e) {
    e.preventDefault();
    setZoom(zoom.scale + (e.deltaY < 0 ? 0.25 : -0.25), e.clientX, e.clientY);
  }, { passive: false });

  /* ---------- 拖拽平移 ---------- */
  imageEl.addEventListener('pointerdown', function (e) {
    if (!zoom.active) return;
    e.preventDefault();
    drag = { on: true, moved: false, startX: e.clientX, startY: e.clientY, baseX: zoom.x, baseY: zoom.y };
    stage.classList.add('is-dragging');
    imageEl.setPointerCapture(e.pointerId);
  });
  imageEl.addEventListener('pointermove', function (e) {
    if (!drag.on) return;
    var dx = e.clientX - drag.startX, dy = e.clientY - drag.startY;
    if (Math.abs(dx) + Math.abs(dy) > 4) drag.moved = true;
    zoom.x = drag.baseX + dx;
    zoom.y = drag.baseY + dy;
    applyTransform();
  });
  ['pointerup', 'pointercancel'].forEach(function (ev) {
    imageEl.addEventListener(ev, function () {
      drag.on = false;
      stage.classList.remove('is-dragging');
      setTimeout(function () { drag.moved = false; }, 0);
    });
  });

  /* ---------- 手机滑动切换 ---------- */
  var swipe = null;
  stage.addEventListener('touchstart', function (e) {
    if (zoom.active || e.touches.length !== 1) return;
    swipe = { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
  }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (!swipe) return;
    var dx = e.changedTouches[0].clientX - swipe.x;
    var dy = e.changedTouches[0].clientY - swipe.y;
    var dt = Date.now() - swipe.t;
    swipe = null;
    if (dt < 600 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      stopPlay();
      show(index + (dx < 0 ? 1 : -1));
    }
  }, { passive: true });

  /* ---------- 幻灯片播放 ---------- */
  var ICON_PLAY  = '<svg viewBox="0 0 24 24"><polygon points="7 5 19 12 7 19"/></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 24 24"><line x1="9" y1="5" x2="9" y2="19"/><line x1="15" y1="5" x2="15" y2="19"/></svg>';

  function startPlay() {
    playing = true;
    lb.classList.add('is-playing');
    btnPlay.innerHTML = ICON_PAUSE;
    btnPlay.classList.add('is-active');
    var startTime = performance.now();
    function tick(now) {
      var pct = Math.min((now - startTime) / PLAY_INTERVAL, 1);
      progress.style.width = pct * 100 + '%';
      if (pct >= 1) {
        show(index + 1);
        startTime = now;
      }
      progressRAF = requestAnimationFrame(tick);
    }
    progressRAF = requestAnimationFrame(tick);
  }
  function stopPlay() {
    if (!playing) return;
    playing = false;
    cancelAnimationFrame(progressRAF);
    progress.style.width = '0';
    lb.classList.remove('is-playing');
    btnPlay.innerHTML = ICON_PLAY;
    btnPlay.classList.remove('is-active');
  }
  btnPlay.addEventListener('click', function () { playing ? stopPlay() : startPlay(); });

  /* ---------- 全屏 ---------- */
  btnFull.addEventListener('click', function () {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (lb.requestFullscreen) {
      lb.requestFullscreen().catch(function () {});
    }
  });
  document.addEventListener('fullscreenchange', function () {
    btnFull.classList.toggle('is-active', !!document.fullscreenElement);
  });

  /* ---------- 九宫格视图 ---------- */
  function toggleGrid(force) {
    var on = force !== undefined ? force : !lb.classList.contains('is-grid');
    lb.classList.toggle('is-grid', on);
    btnGrid.classList.toggle('is-active', on);
    if (on) stopPlay();
  }
  btnGrid.addEventListener('click', function () { toggleGrid(); });

  /* ---------- 键盘操作 ---------- */
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-open')) return;
    switch (e.key) {
      case 'Escape':
        if (lb.classList.contains('is-grid')) toggleGrid(false);
        else close();
        break;
      case 'ArrowLeft':  stopPlay(); show(index - 1); break;
      case 'ArrowRight': stopPlay(); show(index + 1); break;
      case ' ':
        e.preventDefault();
        playing ? stopPlay() : startPlay();
        break;
    }
  });

  /* ---------- 变体切换联动 ----------
     Rise / 各主题的变体事件名不统一,常见几种都监听。
     变体有 featured_media 时,同步当前索引;
     若查看器已打开则直接跳转。 */
  function syncToMediaId(mediaId) {
    if (!mediaId) return;
    for (var k = 0; k < items.length; k++) {
      if (String(items[k].id) === String(mediaId)) {
        if (lb.classList.contains('is-open')) show(k);
        else index = k;
        return;
      }
    }
  }
  ['variant:change', 'variantChange', 'variant:changed'].forEach(function (evName) {
    document.addEventListener(evName, function (e) {
      var v = e.detail && (e.detail.variant || e.detail);
      var media = v && (v.featured_media || v.featuredMedia);
      syncToMediaId(media && media.id);
    });
  });

  /* ---------- 公开 API(方便其他脚本调用) ---------- */
  window.SakuraLightbox = {
    open: open,
    close: close,
    show: show,
    showMediaId: function (id) {
      for (var k = 0; k < items.length; k++) {
        if (String(items[k].id) === String(id)) return open(k);
      }
    }
  };
})();
